import {lazy} from 'react';

export const CompactOffersListLazy = lazy(() => import(/* webpackChunkName: "compactOffersList" */ '.'));
